import React from 'react';

/**
 * @param {number} confirmedPercent – percentage already confirmed (blue)
 * @param {number} pendingPercent   – percentage in mempool (red)
 */
export default function DoubleProgressBar({ confirmedPercent, pendingPercent}) {
  return (
    <div className="w-full bg-gray-200 rounded-full h-2 flex overflow-hidden relative">
      <div
        className="bg-red-600 h-full rounded-full"
        style={{ width: `${pendingPercent + confirmedPercent}%` }}
      />
      <div
        className="bg-blue-600 rounded-full h-full absolute left-0"
        style={{ width: `${confirmedPercent}%` }}
      />
    </div>
  );
}